import { Configuration, LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 *
 */

let RedirectUri =
  typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.hostname}`
    : "";
if (typeof window !== "undefined") {
  if (window.location.port !== "") {
    RedirectUri = `${RedirectUri}:${window.location.port}`;
  }
}

RedirectUri = RedirectUri
export const MSAL_CONFIG = {
  auth: {
    clientId: `${process.env.REACT_APP_PUBLIC_APPLICTION_ID}`,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_PUBLIC_TENANT_ID}`,
    redirectUri: RedirectUri
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
        case LogLevel.Error:
          // console.error(message);
          return;
        case LogLevel.Info:
          // console.info(message);
          return;
        case LogLevel.Verbose:
          // console.debug(message);
          return;
        case LogLevel.Warning:
          // console.warn(message);
          return;
        }
      }
    }
  }
};



/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
*/

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
*/

// export const graphConfig = {
//   graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
//   graphMyPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo"
// };